export enum SocialPlatform {
  Instagram, 
  YouTube, 
  VK, 
  SoundCloud, 
  Spotify, 
  AppleMusic,
  TikTok,
  Website,
  YandexMusic,
  Telegram
}

export function socialPlatformFromApiValue(raw: unknown): SocialPlatform | null {
  if (raw === null || raw === undefined || raw === '') {
    return null;
  }
  if (typeof raw === 'number') {
    const n = Math.trunc(raw);
    if (n < SocialPlatform.Instagram || n > SocialPlatform.Telegram) {
      return null;
    }
    const rev = (SocialPlatform as Record<number, unknown>)[n];
    return typeof rev === 'string' ? (n as SocialPlatform) : null;
  }
  if (typeof raw === 'string') {
    const s = raw.trim();
    if (/^\d+$/.test(s)) {
      return socialPlatformFromApiValue(Number(s));
    }
    const byName = SocialPlatform[s as keyof typeof SocialPlatform];
    return typeof byName === 'number' ? byName : null;
  }
  return null;
}

export interface SocialLinkDto {
  platform?: SocialPlatform;
  url: string;
}

export interface PerformerRateDto {
  pricePerHour?: number;
  pricePerSet?: number;
  description: string;
}

export interface VideoUrlDto {
  url: string;
  order: number;
}

export enum PerformerType {
  Band = 1,
  Solo,
  Cover,
  Acoustic,
  Singer,
  Dj,
  Instrumentalist,
  Performance
}

export interface CreatePerformerDto {
  city: number;
  name: string;
  bio?: string;
  socialLinks?: SocialLinkDto[];
  performerRate: PerformerRateDto;
  photoKeys?: string[];
  slug?: string;
  genres: number[];
  performerTypes: PerformerType[];
  videos?: VideoUrlDto[];
  photoKey?: string;
  musicPlaylistUrl?: string;
  hashTags?: string[];
  bookingAvailableText?: string;
}

export interface CreatePerformerResponseDto {
  id: string;
  slug: string;
  isPublished: boolean;
  publicUrl?: string;
}

/** Request body for updating performer profile */
export interface UpdatePerformerProfileDto {
  name: string;
  city: number;
  bio?: string;
  genres?: number[];
  performerTypes?: PerformerType[];
  videos?: VideoUrlDto[];
  hashTags?: string[];
  musicPlaylistUrl?: string;
  socialLinks?: SocialLinkDto[];
}

export interface UserPerformerListItemDto {
  id: string;
  name: string;
  city: number;
  slug: string;
  thumbnailPath: string;
  isPublished: boolean;
  createdAt: string;
}

export interface CheckSlugResponseDto {
  isTaken: boolean;
}

/** Performers search parameters. */
export interface PerformersIndexParams {
  page?: number;
  pageSize?: number;
  [key: string]: any;
}

/** Hashtags search response. */
export interface HashtagsResponseDto {
  hashtags?: string[];
}

/** Request body for updating photos. */
export interface UpdatePhotosDto {
  picKeys: string[];
}

export interface PhotoVm {
  path: string;
  thumbnailPath?: string;
  /** Key to pass when updating photos list (preserve existing). */
  key?: string;
}

export interface VideoDto {
  url: string;
  vkVideo0Id?: string;
  vkVideoId?: string;
  order: number;
}

export interface PerformerBookingPhoneVm {
  code?: string | null;
  number?: string;
  hasTelegram?: boolean;
  hasMax?: boolean;
}

export interface PerformerProfileDto {
  id?: string;
  slug?: string;
  name?: string;
  city?: number;
  bio?: string;
  image?: PhotoVm;
  photos?: PhotoVm[];
  /** Keys of gallery photos (same order as photos). If set, use when updating gallery. */
  photoKeys?: string[];
  genres?: number[];
  performerTypes?: PerformerType[];
  videos?: VideoDto[];
  hashTags?: string[];
  musicPlaylistUrl?: string;
  socialLinks?: SocialLinkDto[];
  videoCount?: number;
  musicAvailable?: boolean;
  isPublished?: boolean;
  phoneImage?: PhotoVm | null;
  bookingPhone?: PerformerBookingPhoneVm | null;
}
